import { mapState, mapMutations } from "vuex";

import * as apis from "@/api";
import { conversion, GetItemDuration } from "@/tool";
import { format_case_name } from "@/filters/format_case_name";

import open_sound from "@/assets/audio/unlock.mp3";
import run_sound from "@/assets/audio/roll.mp3";
import win_sound from "@/assets/audio/battlewin.ogg";
import lose_sound from "@/assets/audio/lose.ogg";

import Picture from "@/components/picture";
import Button from "@/components/button";
import BlockTitle from "@/components/block_title";
// import Award from "@/components/award";
import InteractivePanel from "@/components/interactive_panel";

// import CaseOpening from '@/partials/case_opening/single.vue';
// import CaseOpeningMore from "@/partials/case_opening/more.vue";
import CustomButton from "@/partials/custom_button";
import { CustomBlockTitle } from "@/partials/custom_block_title";

import liveDropBox from "@/partials/live_drop_box";
// import  RewardModal  from '@/components/UI/RewardModal';

import { RewardModal, Award } from "@/components/UI";

export default {
  components: {
    "p-custom-button": CustomButton,
    "p-custom-block-title": CustomBlockTitle,

    "c-picture": Picture,
    "c-button": Button,
    "c-block-title": BlockTitle,
    "c-award": Award,
    "c-interactive-panel": InteractivePanel,
    "p-liveDropBox": liveDropBox,
    "c-RewardModal": RewardModal,
  },

  filters: {
    conversion,
    format_case_name,
    GetItemDuration,
  },

  data() {
    return {
      /** 箱子信息 */
      case_info: {},

      /** 箱子奖品列表 */
      case_awards: [],

      /** 箱子奖品列表 */
      drop_awards: [],

      /** 开箱获得奖品列表 */

      case_opened_awards: [],

      caseListPannelActive: 0,
      /** 开箱个数 */
      case_open_number: 1,

      /** 是否跳过开箱动画 */
      is_jump_case_open_animation: false,

      /** 是否为开箱试玩 */
      is_case_open_try: false,

      /** 开箱CDK */
      case_open_cdk: "",

      /** cdk开箱模态框显示 */
      is_case_open_cdk_modal_show: false,

      /** 开箱是否正在运行 */
      isRunning: false,

      /** 奖品模态框显示 */
      awards_modal_flag: false,

      /** 音乐 */
      sounds: [],

      notice_modal_show: false,

      price_range_index: 0,
      price_range: [
        { min: 0, max: 99999999 },
        { min: 0, max: 1 },
        { min: 2, max: 19 },
        { min: 20, max: 49 },
        { min: 50, max: 99 },
        { min: 100, max: 999999 },
      ],
    };
  },
  computed: {
    ...mapState(["user", "config", "isMute", "boxList"]),

    /** 推荐宝箱 */
    cateCaseList() {
      return (cate) => {
        return this.boxList?.list?.filter((_) => _.catagory == cate);
      };
    },
    cateCaseNum() {
      return () => {
        if (this.$route?.query?.name == '五五箱') {
          return [1]
        }
        return [1, 2, 3, 10, 50]
      }
    },

    /** 开箱成本价 */
    case_open_amount: (vm) => vm.case_info.price * vm.case_open_number,

    /** 开箱结果奖品金额合计 */
    case_opened_awards_amount: (vm) =>
      vm.case_opened_awards
        .filter((_) => !_.isConvert)
        .reduce((acc, { price }) => acc + price, 0),

    /** 开箱结果盈利比率 */
    case_opened_profit_ratio: (vm) => {
      if (
        vm.case_open_amount <= 0 ||
        vm.case_opened_awards_amount < vm.case_open_amount
      )
        return 0;

      const profit = vm.case_opened_awards_amount;

      const profit_ratio = profit / vm.case_open_amount;

      return profit_ratio;
    },

    /** 快标题宽度 */
    block_title_width: (vm) => (vm.$screen.mobile ? "100%" : "44%"),

    calcViewRate() {
      return function (rate) {
        return (
          Math.round(
            (rate /
              this.case_awards.map((_) => _.viewRate).reduce((a, b) => a + b)) *
            1000000
          ) / 10000
        );
      };
    },
  },

  watch: {},

  async beforeRouteUpdate(to, from, next) {
    await next();

    await this.get_case_info();
  },
  async mounted() { },
  async created() {
    this.is_jump_case_open_animation =
      sessionStorage.getItem("is_jump_case_open_animation") === "true";

    var sounds = {
      open: new Audio(open_sound),
      run: new Audio(run_sound),
      win: new Audio(win_sound),
      lose: new Audio(lose_sound),
    };

    this.sounds = sounds;

    await this.get_case_info();
  },

  methods: {
    ...mapMutations(["setSpinShow"]),
    ...mapMutations(["setloginModal", "setPayModal"]),

    conversion,
    format_case_name,

    async getCaseDropList() {
      const cases_opened_response = await apis.indexHistory({
        caseId: this.case_info.caseId,
      });
      this.drop_awards = [];
      cases_opened_response.data.data.list.forEach((item, index) => {
        // console.log("insert drop data" + item.item.name);
        // this.drop_awards.push(
        //   this.case_awards.find((_) => _.itemname === item.item.name)
        // );
        const foundItem = this.case_awards.find((_) => _.itemname === item.item.name);
        if (foundItem !== undefined) {
            this.drop_awards.push(foundItem);
        }
      });
      // console.log("dropList:");
      // console.log(this.drop_awards);
    },

    /** 跳过开箱动画 切换  */
    async toggle_is_jump_case_open_animation() {
      sessionStorage.setItem(
        "is_jump_case_open_animation",
        String(this.is_jump_case_open_animation)
      );
    },

    /** 切换CDK开箱模态显示状态 */
    async toggle_case_open_cdk_modal_show() {
      // 未登录处理
      if (!this.is_case_open_cdk_modal_show && !this.user.nickname) {
        this.setloginModal(true);

        return;
      }
      this.is_case_open_cdk_modal_show = !this.is_case_open_cdk_modal_show;
    },

    /** 获取箱子信息 */
    async get_case_info() {
      const case_info_response = await apis.api_CaseDetail(
        this.$route.params.id
      );
      this.setSpinShow(false);
      if (case_info_response.data.code !== 0) {
        return;
      }

      const respone = case_info_response.data.data;

      this.case_info = respone.caseInfo;
      this.case_awards = respone.items;
      var totalRate = this.case_awards
        .map((_) => _.viewRate)
        .reduce((a, b) => a + b, 0);
      this.case_awards.forEach((item, index) => {
        item.viewRate = Math.ceil((item.viewRate / totalRate) * 10000) / 100;
      });

      setTimeout(() => {
        this.getCaseDropList();
      }, 500);
    },
    /** 模拟开箱 */
    async case_open_emu() {
      if (this.isRunning)
        //如果开箱为运行状态则不运行
        return;

      this.is_case_open_try = true; //设置为试玩

      this.isRunning = true; //设置状态

      var sortArray = this.case_awards.slice();

      sortArray.sort(function (a, b) {
        return a.viewRate - b.viewRate;
      });

      var rditemList = [];
      var toatalRate = sortArray
        .map((_) => _.viewRate)
        .reduce((a, b) => a + b, 0);

      for (var i = 0; i < this.case_open_number; i++) {
        rditemList.push(sortArray[sortArray.length - 1]);

        for (var z = 0; z < sortArray.length; z++) {
          var rdnum = Math.floor(Math.random() * toatalRate);
          if (rdnum <= sortArray[z].viewRate) {
            rditemList[i] = sortArray[z];
            break;
          }
        }
      }

      // 处理奖品数组
      this.case_opened_awards = rditemList;

      this.case_opened_awards.forEach((item, index) => {
        this.$set(item, "isConvert", false);
        this.$set(item, "converting", false);
      });

      if (this.case_open_number <= 1) {
        this.$refs.case_opening_box.start(this.case_opened_awards[0]); //开箱开始运行
      } else {
        this.$refs.case_opening_box_more.start(this.case_opened_awards); //开箱开始运行
      }

      this.playStartAudio();
    },
    /**  真实开箱 */
    async case_open(type) {
      // 未登录处理
      if (!this.user.nickname) {
        this.setloginModal(true);
        return;
      }

      if (this.isRunning)
        //如果开箱为运行状态则不运行
        return;

      this.is_case_open_try = false; //设置不为试玩

      this.isRunning = true; //设置状态
      // 开箱接口选择
      const case_opened_api = {
        normal: apis.userOpenMany,
        cdk: apis.userOpen_cdk,
      }[type];

      const params = {
        normal: {
          id: this.case_info.caseId,
          count: this.case_open_number,
        },
        cdk: {
          id: this.case_info.caseId,
          cdkey: this.case_open_cdk,
        },
      }[type];
      if (this.$route?.query?.uhc) Object.assign(params, { useHappyCoin: true });

      const case_opened_response = await case_opened_api(params);

      // 开箱失败
      if (case_opened_response.data.code !== 0) {
        this.$toast.error(case_opened_response.data.msg);

        if (case_opened_response.data.msg.indexOf("充值") > -1) {
          this.setPayModal(true);
        }
        this.isRunning = false; //设置状态
        return;
      }

      // 处理奖品数组
      this.case_opened_awards = case_opened_response.data.data;

      this.case_opened_awards.forEach((item, index) => {
        this.$set(item, "isConvert", false);
        this.$set(item, "converting", false);
      });

      if (type == "cdk") this.toggle_case_open_cdk_modal_show();

      this.$store.commit("setInfo");

      await this.$nextTick();

      // if (this.case_open_number <= 1) {
      //   this.$refs.case_opening_box.start(this.case_opened_awards[0]); //开箱开始运行
      // } else {
      //   this.$refs.case_opening_box_more.start(this.case_opened_awards); //开箱开始运行
      // }

      this.playStartAudio();
    },
    playStartAudio() {
      if (!this.isMute && !this.is_jump_case_open_animation) {
        this.sounds["open"].currentTime = 0;
        this.sounds["open"].play();
        this.on_case_opened();
      }
    },
    /** 开箱结束事件 */
    async on_case_opened() {
      this.isRunning = false; //设置开箱运行状态
      this.awards_modal_flag = true;

      this.$refs.case_reward_ui.reset();

      this.case_opened_awards.forEach((item, index) => {
        this.$refs.case_reward_ui.pushItem(
          item.itemname,
          item.mSerial,
          item.itempic,
          item.rarity,
          item.price
        );
      });

      // 刷新当前箱子信息
      this.get_case_info();

      if (!this.isMute) {
        if (
          this.case_opened_awards.filter((_) => _.price > this.case_info.price)
            .length > 0
        ) {
          this.sounds["win"].currentTime = 0;
          this.sounds["win"].play();
        } else {
          this.sounds["lose"].currentTime = 0;
          this.sounds["lose"].play();
        }
      }

      this.$refs.case_reward_ui.show();
    },

    /** 开箱奖品折现 */
    async case_opened_awards_discount(award) {
      var awards_Serial = this.case_opened_awards.map((award) => award.mSerial);

      if (award) {
        awards_Serial = [award.mSerial];
      }

      this.case_opened_awards.forEach((item, index) => {
        if (awards_Serial.indexOf(item.mSerial) > -1) {
          item.converting = true;
        }
      });

      const awards_discount_response = await apis.api_SellItem({
        lstmSerial: awards_Serial,
      });

      // 折现失败
      if (awards_discount_response.data.code !== 0) {
        this.$toast.error(awards_discount_response.data.msg);
        return;
      }

      //this.awards_modal_flag = false;

      this.$toast.success(awards_discount_response.data.msg);

      // 更新用户信息
      this.$store.commit("setInfo");

      this.case_opened_awards.forEach((item, index) => {
        if (awards_Serial.indexOf(item.mSerial) > -1) {
          item.isConvert = true;
        }
      });
    },
    pathGo(obj) {
      if (obj.name === "exclusiveDetail") {
        return this.$router.push({
          name: "exclusiveDetail",
          params: { id: obj.id },
          query: { name: obj.category },
        });
      }

      this.$router.push(obj);
    },
  },
};
